import { Avatar as MuiAvatar } from "@material-ui/core";
import { ImageIcon } from "@saleor/macaw-ui";
import { Text } from "@saleor/macaw-ui-next";
import clsx from "clsx";
import React from "react";

import { useAvatarImageStyles } from "./styles";

interface AvatarImageProps {
  initials?: string;
  thumbnail?: string | null;
  avatarProps?: string;
}

const AvatarImage = ({ initials, thumbnail, avatarProps }: AvatarImageProps) => {
  const classes = useAvatarImageStyles();
  const [imageLoadError, setImageLoadError] = React.useState(false);

  React.useEffect(() => {
    setImageLoadError(false);
  }, [thumbnail]);

  const shouldShowFallback = !thumbnail || imageLoadError;

  if (shouldShowFallback && initials) {
    return (
      <MuiAvatar className={clsx(classes.avatar, avatarProps)}>
        <Text size={6} fontWeight="bold" lineHeight={3}>
          {initials}
        </Text>
      </MuiAvatar>
    );
  }

  if (shouldShowFallback) {
    return (
      <MuiAvatar className={clsx(classes.avatar, avatarProps)}>
        <ImageIcon color="primary" data-test-id="imageIcon" />
      </MuiAvatar>
    );
  }

  return (
    <MuiAvatar
      className={clsx(classes.avatar, avatarProps)}
      imgProps={{ onError: () => setImageLoadError(true) }}
      src={thumbnail}
    />
  );
};

export default AvatarImage;
